import { InputField } from "./InputField";
import type { UtdoDisk } from "../types";
import { toNullableInt, toString } from "../util/converters";

export type DisksEditorProps = {
    disk: UtdoDisk;
    validate: (disk: UtdoDisk) => any;
    cancel: () => any;
};

export function DisksEditor(props: DisksEditorProps) {
    let idRef!: HTMLInputElement;
    let titleRef!: HTMLInputElement;
    let releaseRef!: HTMLInputElement;
    let coverRef!: HTMLInputElement;
    let hiddenRef!: HTMLInputElement;

    const cancel = (ev: Event) => {
        ev.preventDefault();
        ev.stopPropagation();
        props.cancel();
    };

    const validate = (ev: Event) => {
        ev.preventDefault();
        ev.stopPropagation();
        const id = toNullableInt(idRef.value);
        const title = toString(titleRef.value);
        const release = toString(releaseRef.value);
        const cover = toString(coverRef.value);
        const hidden = hiddenRef.checked;
        props.validate({
            id,
            title,
            release,
            cover,
            hidden,
        });
    };

    return <form onSubmit={validate} autocomplete="off">
            <input ref={idRef} type="hidden" value={props.disk.id}/>
            <InputField
                ref={titleRef}
                type="text"
                id="disk-title"
                label="Titre"
                required
                value={props.disk.title}/>
            <InputField
                ref={releaseRef}
                type="date"
                id="disk-release"
                label="Sortie"
                required
                value={props.disk.release}/>
            <InputField
                ref={coverRef}
                type="text"
                id="disk-cover"
                label="Pochette"
                required
                value={props.disk.cover}/>
            <InputField
                ref={hiddenRef}
                type="checkbox"
                id="disk-hidden"
                label="Caché"
                value={props.disk?.hidden ?? true}/>
        <div class="actions">
            <input type="submit" value="Enregistrer" class="accent" />
            <button onClick={cancel}>Annuler</button>
        </div>
    </form>;
}